import {LogoTextSize, renderLogoTextSize} from "../../controllers/SystemUmmiaLogoTextController";
import {isNullOrUndefined} from "../../services/Validator";
import {kSystemImages} from "../../constants/images";

export default function SystemScreenTopBarUmmiaLogo({onLogoPressed}) {
    // Used in SystemScreenTopBar to display either Ummia logo text
    // or logo based on screen width

    // BUILD
    return (
        <div className={"flex justify-center items-center"}>
            <div className={`hidden md:block ${renderLogoTextSize(LogoTextSize.SMALL)} ${isNullOrUndefined(onLogoPressed) ? "" : " cursor-pointer"}`}
                 onClick={onLogoPressed}>
                <img className={"h-full object-contain"}
                     src={kSystemImages.neoUmmiaLogoText}
                     alt="Logo texte" />
            </div>
            <div className={`block md:hidden h-[32px] min-h-[32px] max-h-[32px] w-[29px] min-w-[29px] max-w-[29px] mb-[2px] ${isNullOrUndefined(onLogoPressed) ? "" : " cursor-pointer"}`}
                 onClick={onLogoPressed}>
                <img className={"h-full object-contain"}
                     src={kSystemImages.neoUmmiaLogo}
                     alt="Logo" />
            </div>
        </div>
    );
}